/** Desenvolvido by Urnau */
(function () {
        'use strict';

        const init = () => {
            // Verifica se o validador está disponível
            if (!window.uutils || !window.uutils.email_validator) {
                console.log('ℹ️ Validador de email não encontrado. Fluxo padrão da newsletter será mantido.');
                return;
            }

            // Seleciona o formulário original da newsletter
            const originalForm = document.querySelector('#ContactFooter');

            if (!originalForm) {
                console.warn('Formulário de newsletter não encontrado');
                return;
            }

            // Clona o formulário
            const clonedForm = originalForm.cloneNode(true);

            // ========== HIGIENIZAÇÃO DO FORMULÁRIO CLONADO ==========

            // Remove atributos que podem disparar scripts do Shopify
            clonedForm.removeAttribute('action');
            clonedForm.removeAttribute('method');
            clonedForm.removeAttribute('data-cptcha');
            clonedForm.removeAttribute('data-hcaptcha-bound');

            // Remove todos os data-attributes que podem conter bindings
            clonedForm.querySelectorAll('*').forEach(element => {
                Array.from(element.attributes).forEach(attr => {
                    if (attr.name.startsWith('data-')) {
                        element.removeAttribute(attr.name);
                    }
                });
            });

            // Remove inputs hidden que podem disparar scripts
            clonedForm.querySelectorAll('input[type="hidden"]').forEach(input => input.remove());

            // Remove scripts que possam estar dentro do clone
            clonedForm.querySelectorAll('script').forEach(script => script.remove());

            // Remove o hCaptcha do clone
            const clonedCaptcha = clonedForm.querySelector('.h-captcha');
            if (clonedCaptcha) {
                clonedCaptcha.remove();
            }

            // ========== FIM DA HIGIENIZAÇÃO ==========

            // Altera os IDs do formulário clonado para evitar conflitos
            clonedForm.id = 'ContactFooter_Clone';
            clonedForm.classList.add('newsletter-form-cloned');

            // Atualiza IDs dos elementos internos do clone
            const clonedInput = clonedForm.querySelector('input[type="email"]');
            const clonedButton = clonedForm.querySelector('button[type="submit"]');
            const clonedLabel = clonedForm.querySelector('label');

            if (clonedInput) {
                const originalInputId = clonedInput.id;
                clonedInput.id = originalInputId + '_Clone';
                if (clonedLabel) {
                    clonedLabel.setAttribute('for', clonedInput.id);
                }
            }

            if (clonedButton) {
                clonedButton.id = (clonedButton.id || 'Subscribe') + '_Clone';
                clonedButton.removeAttribute('name');
            }

            // Cria container para mensagem de erro
            const errorMessage = document.createElement('div');
            errorMessage.className = 'newsletter-validation-error';
            errorMessage.style.cssText = 'display: none; color: #d9534f; font-size: 1rem; margin-top: 10px; padding: 10px; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px;';

            // Insere o clone após o formulário original
            originalForm.parentNode.insertBefore(clonedForm, originalForm.nextSibling);
            clonedForm.parentNode.insertBefore(errorMessage, clonedForm.nextSibling);

            // Oculta o formulário original
            originalForm.style.display = 'none';

            // Adiciona evento de submit no formulário clonado
            clonedForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const email = clonedInput.value.trim();

                // Remove estados de erro anteriores
                errorMessage.style.display = 'none';
                errorMessage.textContent = '';
                clonedInput.style.border = '';

                // Desabilita o botão durante validação
                clonedButton.disabled = true;
                const originalButtonText = clonedButton.textContent;
                clonedButton.textContent = 'Validando...';

                try {
                    // Executa a validação do email
                    await window.uutils.email_validator(email);

                    console.log('✅ Email validado com sucesso:', email);

                    clonedButton.textContent = 'Enviando...';

                    // Preenche o formulário original com o email validado
                    const originalInput = originalForm.querySelector('input[type="email"]');
                    if (originalInput) {
                        originalInput.value = email;
                        console.log('✅ Email preenchido no formulário original');
                    }

                    // Aguarda um momento para garantir que o valor foi atualizado
                    await new Promise(resolve => setTimeout(resolve, 100));

                    // Dispara o click no botão do formulário original (simula ação manual)
                    const originalButton = originalForm.querySelector('button[type="submit"]');
                    if (originalButton) {
                        console.log('✅ Disparando submit do formulário original via click');
                        originalButton.click();
                    } else {
                        console.warn('⚠️ Botão original não encontrado, usando submit direto');
                        originalForm.submit();
                    }

                    // Aguarda para garantir que edrone e outros scripts capturaram
                    await new Promise(resolve => setTimeout(resolve, 1000));

                    console.log('✅ Redirecionando...');

                    // Redireciona para a página com parâmetro de sucesso
                    window.location.href = window.location.pathname + '?customer_posted=true';

                } catch (error) {
                    // Exibe mensagem de erro
                    console.error('❌ Erro na validação:', error);
                    errorMessage.textContent = error.message || 'Erro ao validar o e-mail. Por favor, tente novamente.';
                    errorMessage.style.display = 'block';

                    // Adiciona borda vermelha no input
                    clonedInput.style.border = '2px solid #d9534f';

                    // Reabilita o botão
                    clonedButton.disabled = false;
                    clonedButton.textContent = originalButtonText;
                }
            });

            console.log('✅ Sistema de validação de newsletter inicializado');
            console.info("'newsletter-email-validation' carregado com sucesso");
        };

        // Inicializa quando o DOM estiver pronto
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    })();
